import { styled } from "@linaria/react";
import React from "react";
import BaseBanner from "../BaseBanner/BaseBanner";
import clsx from "clsx";
import { buttonCss } from "components/Button/Button";

const ClosedCard = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #fff;
  width: 544px;
`;

const CardHeader = styled.div`
  font-family: "FriezeSans";
  font-size: 15px;
  padding-block: 14px;
  text-align: center;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  border-bottom: 1px solid #000;
`;

const CardBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 18px;
`;

const EventName = styled.h1`
  width: 459px;
  margin: 24px 0 15px 0;
  text-align: center;
  font-family: "SinaNova";
  font-size: 45px;
  line-height: 46px;
  letter-spacing: 0.18px;
`;

type AdditionalInfoProps = {
  withLink?: boolean;
};
const AdditionalInfo = styled.p<AdditionalInfoProps>`
  width: 380px;
  margin-bottom: ${(props) => (props.withLink ? "40px" : "0px")};
  text-align: center;
  font-family: "SinaNova";
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.18px;
`;

const LearnMore = styled.a`
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #000;
  font-family: "Frieze";
  font-weight: 400;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.79px;
  text-transform: uppercase;

  &:hover {
    color: #fff;
    background-color: #000;
  }
`;

type ClosedBannerProps = {
  text?: string;
  link?: {
    name?: string;
    path?: string;
  };
};

const ClosedBanner = ({ text, link }: ClosedBannerProps) => {
  return (
    <BaseBanner bgColor="#d8d8d870">
      <ClosedCard>
        <CardHeader>Thank you for visiting</CardHeader>

        <CardBody>
          {text && <EventName>{text}</EventName>}
          <AdditionalInfo withLink={!!text}>
            For the latest information on all our forthcoming events please visit frieze.com/fairs
          </AdditionalInfo>

          {link?.name && (
            <LearnMore href={link.path} className={clsx(buttonCss, "uppercase")}>
              {link.name}
            </LearnMore>
          )}
        </CardBody>
      </ClosedCard>
    </BaseBanner>
  );
};

export default ClosedBanner;
